// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeScreen_container__25rp5","navContainer":"HomeScreen_navContainer__HPcBI"};